export default "__VITE_ASSET__3ltXVxQq__"